import React, { useState, useEffect } from "react";
import { Modal, Button, Form, FloatingLabel } from "react-bootstrap";
import styles from "./stylesAdmin.module.css"
import { Establecimiento  } from "../../types/interfaces";
import { useLoading } from "../../components/LoadingContext";

interface AddEstablecimientoModalProps {
  show: boolean;
  onHide: () => void;
  showNotification: (message: string, variant: "success" | "danger") => void;
  onAddItem?: (item: any) => void;
}

export default function AddEstablecimientoModal({
  show,
  onHide,
  showNotification,
  onAddItem, 
}: AddEstablecimientoModalProps) {
  const { setLoading } = useLoading();
  const [formData, setFormData] = useState<any>({});
  // const [establecimientos, setEstablecimientos] = useState<Establecimiento[]>([]);
  const [errors, setErrors] = useState<any>({});

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const [establecimientosResponse] = await Promise.all([
  //         fetch(`${process.env.REACT_APP_API_URL}/api/admin/allEstablecimientos`, ),
  //       ]);

  //       if (!establecimientosResponse.ok) {
  //         throw new Error("Network response was not ok");
  //       }

  //       const [establecimientosData] = await Promise.all([
  //         establecimientosResponse.json(),
  //       ]);

  //       setEstablecimientos(establecimientosData);
  //     } catch (error) {
  //       console.error("Failed to fetch data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [setLoading]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors: any = {};
    let hasErrors = false;

    if (!formData.nombre) {
        newErrors.nombre = "Este campo es obligatorio.";
        hasErrors = true;
    } else if (formData.nombre.length < 5) {
        newErrors.nombre = "Este campo debe tener al menos 5 caracteres.";
        hasErrors = true;
    }

    if (!formData.domicilio_calle) {
        newErrors.domicilio_calle = "Este campo es obligatorio.";
        hasErrors = true;
    } else if (formData.domicilio_calle.length < 3) {
        newErrors.domicilio_calle = "Este campo debe tener al menos 3 caracteres.";
        hasErrors = true;
    }

    if (!formData.domicilio_numero) {
        newErrors.domicilio_numero = "Este campo es obligatorio.";
        hasErrors = true;
    }

    if (!formData.domicilio_cp) {
        newErrors.domicilio_cp = "Este campo es obligatorio.";
        hasErrors = true;
    } else if (!/^\d+$/.test(formData.domicilio_cp)) {
        newErrors.domicilio_cp = "Este campo debe ser un número.";
        hasErrors = true;
    }

    if (!formData.localidad_nombre) {
        newErrors.localidad_nombre = "Este campo es obligatorio.";
        hasErrors = true;
    } else if (formData.localidad_nombre.length < 3) {
        newErrors.localidad_nombre = "Este campo debe tener al menos 3 caracteres.";
        hasErrors = true;
    }

    if (!formData.provincia_nombre) {
        newErrors.provincia_nombre = "Este campo es obligatorio.";
        hasErrors = true;
    } else if (formData.provincia_nombre.length < 3) {
        newErrors.provincia_nombre = "Este campo debe tener al menos 3 caracteres.";
        hasErrors = true;
    }

    if (!formData.lat) {
        newErrors.lat = "Este campo es obligatorio.";
        hasErrors = true;
    } else if (!/^[-\d]+(\.\d+)?$/.test(formData.lat)) {
        newErrors.lat = "Este campo debe ser un número decimal válido.";
        hasErrors = true;
    } else {
        const lat = parseFloat(formData.lat);
        if (lat >= 0 || lat < -90) {
            newErrors.lat = "Este campo debe ser un número negativo entre -90 y 0.";
            hasErrors = true;
        }
    }

    if (!formData.lng) {
        newErrors.lng = "Este campo es obligatorio.";
        hasErrors = true;
    } else if (!/^[-\d]+(\.\d+)?$/.test(formData.lng)) {
        newErrors.lng = "Este campo debe ser un número decimal válido.";
        hasErrors = true;
    } else {
        const lng = parseFloat(formData.lng);
        if (lng >= 0 || lng < -180) {
            newErrors.lng = "Este campo debe ser un número negativo entre -180 y 0.";
            hasErrors = true;
        }
    }

    setErrors(newErrors);
    return !hasErrors;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    const transformedData = {
        nombre: formData.nombre,
        domicilio_calle: formData.domicilio_calle,
        domicilio_numero: formData.domicilio_numero,
        domicilio_referencia: formData.domicilio_referencia,
        domicilio_cp: formData.domicilio_cp,
        localidad_nombre: formData.localidad_nombre,
        provincia_nombre: formData.provincia_nombre,
        lat: formData.lat,
        lng: formData.lng
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/createEstablecimiento`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(transformedData),
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error('Failed to add establecimiento');
      }
  
      const addedEstablecimiento = await response.json();
  
      const establecimientoDetailsResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/establecimiento/${addedEstablecimiento.id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      const establecimientoDetails = await establecimientoDetailsResponse.json();
  
      showNotification("Establecimiento añadido con éxito", "success");
      setFormData({});
      onHide();

      if (onAddItem) onAddItem(establecimientoDetails);
    } catch (error) {
      showNotification("Error al añadir establecimiento", "danger");
      console.error('Error adding establecimiento:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} className={styles.modalContainer}>
              <Form onSubmit={handleSubmit}>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>Agregar Establecimiento</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>


          <FloatingLabel controlId="floatingInputNombre" label="Nombre" className="mb-3">
            <Form.Control type="text" placeholder="Nombre" name="nombre" onChange={handleInputChange} value={formData.nombre || ""} />
          </FloatingLabel>
          {errors.nombre && <div className={styles.errors}>{errors.nombre}</div>}
          <FloatingLabel controlId="floatingInputDomicilioCalle" label="Domicilio" className="mb-3">
            <Form.Control type="text" placeholder="Domicilio" name="domicilio_calle" onChange={handleInputChange} value={formData.domicilio_calle || ""} />
          </FloatingLabel>
          {errors.domicilio_calle && <div className={styles.errors}>{errors.domicilio_calle}</div>}
          <FloatingLabel controlId="floatingInputDomicilioNumero" label="Número" className="mb-3">
            <Form.Control type="text" placeholder="Número" name="domicilio_numero" onChange={handleInputChange} value={formData.domicilio_numero || ""} />
          </FloatingLabel>
          {errors.domicilio_numero && <div className={styles.errors}>{errors.domicilio_numero}</div>}
          <FloatingLabel controlId="floatingInputDomicilioReferencia" label="Referencia" className="mb-3">
            <Form.Control type="text" placeholder="Referencia" name="domicilio_referencia" onChange={handleInputChange} value={formData.domicilio_referencia || ""} />
          </FloatingLabel>
          <FloatingLabel controlId="floatingInputDomicilioCp" label="Codigo postal" className="mb-3">
            <Form.Control type="text" placeholder="Codigo postal" name="domicilio_cp" onChange={handleInputChange} value={formData.domicilio_cp || ""} />
          </FloatingLabel>
          {errors.domicilio_cp && <div className={styles.errors}>{errors.domicilio_cp}</div>}
          <FloatingLabel controlId="floatingInputLocalidadNombre" label="Localidad" className="mb-3">
            <Form.Control type="text" placeholder="Localidad" name="localidad_nombre" onChange={handleInputChange} value={formData.localidad_nombre || ""} />
          </FloatingLabel>
          {errors.localidad_nombre && <div className={styles.errors}>{errors.localidad_nombre}</div>}
          <FloatingLabel controlId="floatingInputProvinciaNombre" label="Provincia" className="mb-3">
            <Form.Control type="text" placeholder="Provincia" name="provincia_nombre" onChange={handleInputChange} value={formData.provincia_nombre || ""} />
          </FloatingLabel>
          {errors.provincia_nombre && <div className={styles.errors}>{errors.provincia_nombre}</div>}
          <FloatingLabel controlId="floatingInputLat" label="Latitud" className="mb-3">
            <Form.Control type="text" placeholder="Latitud" name="lat" onChange={handleInputChange} value={formData.lat || ""} />
          </FloatingLabel>
          {errors.lat && <div className={styles.errors}>{errors.lat}</div>}
          <FloatingLabel controlId="floatingInputLng" label="Longitud" className="mb-3">
            <Form.Control type="text" placeholder="Longitud" name="lng" onChange={handleInputChange} value={formData.lng || ""} />
          </FloatingLabel>
          {errors.lng && <div className={styles.errors}>{errors.lng}</div>}
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
      <Button variant="primary" type="submit">Aceptar</Button>
      </Modal.Footer>
      </Form>
    </Modal>
  );
}
